import { globalEntitlements } from '../utils/globalEntitlements';

export const getAnnualReportConfig = (enableAnnualReportV2Journey) => ({
  hero: {
    buyBox: [{
      bulletPoints: [
        { title: 'productPage.annualReport.buyBox.bulletPoint1' },
        { title: 'productPage.annualReport.buyBox.bulletPoint2' },
        { title: 'productPage.annualReport.buyBox.bulletPoint3' }
      ],
      productName: 'productPage.annualReport.buyBox.productName',
      interactService: {
        service: enableAnnualReportV2Journey ? 'llc_annual_report' : 'annual_report',
        ctaType: enableAnnualReportV2Journey ? 'internalCheckout' : 'externalCheckout'
      }
    }],
    headerPicture: {
      src: '/s2/raster/glasses-review-documents.png',
      alt: 'productPage.annualReport.heroPicture.altText'
    },
    headline: 'productPage.annualReport.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    subheader: 'productPage.annualReport.page.subheader'
  },
  benefit: {
    title: 'productPage.annualReport.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/sentimentverysatisfiedrounded.svg',
        title: 'productPage.annualReport.valueProp.propTitle1',
        description: 'productPage.annualReport.valueProp.shortCopy1'
      },
      {
        icon: '/s2/material-icons/accesstimerounded.svg',
        title: 'productPage.annualReport.valueProp.propTitle2',
        description: 'productPage.annualReport.valueProp.shortCopy2'
      },
      {
        icon: '/s2/material-icons/radarrounded.svg',
        title: 'productPage.annualReport.valueProp.propTitle3',
        description: 'productPage.annualReport.valueProp.shortCopy3'
      }
    ]
  },
  highlight: {
    icon: '/s2/material-icons/thumbuprounded.svg',
    title: 'productPage.annualReport.topFeature.title',
    subheader: 'productPage.annualReport.topFeature.subheader',
    image: '/s2/raster/talk-counter-kitchen.png',
    alt: 'productPage.annualReport.topFeature.altText'
  },
  howItWorks: {
    title: 'productPage.annualReport.howItWorks.title',
    items: [
      {
        title: 'productPage.annualReport.howItWorks.step1',
        description: 'productPage.annualReport.howItWorks.shortDescription1'
      },
      {
        title: 'productPage.annualReport.howItWorks.step2',
        description: 'productPage.annualReport.howItWorks.shortDescription2'
      },
      {
        title: 'productPage.annualReport.howItWorks.step3',
        description: 'productPage.annualReport.howItWorks.shortDescription3'
      }
    ],
    image: '/s2/raster/papers-reading-apron.png',
    alt: 'productPage.annualReport.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true
  },
  faqs: {
    title: 'productPage.annualReport.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.annualReport.frequentlyAskedQuestions.faq1',
        answer: 'productPage.annualReport.frequentlyAskedQuestions.faqAnswer1'
      },
      {
        question: 'productPage.annualReport.frequentlyAskedQuestions.faq2',
        answer: 'productPage.annualReport.frequentlyAskedQuestions.faqAnswer2'
      },
      {
        question: 'productPage.annualReport.frequentlyAskedQuestions.faq3',
        answer: 'productPage.annualReport.frequentlyAskedQuestions.faqAnswer3'
      },
      {
        question: 'productPage.annualReport.frequentlyAskedQuestions.faq4',
        answer: 'productPage.annualReport.frequentlyAskedQuestions.faqAnswer4'
      }
    ]
  },
  assistance: {
    title: 'productPage.annualReport.needAssistance.title',
    getInTouch: 'productPage.annualReport.needAssistance.getInTouch',
    actions: 'productPage.annualReport.needAssistance.actions'
  },
  getBuyButtonConfig: globalEntitlements({ ctaText: 'productPage.annualReport.buyBox.buttonLabel' })
    .formedByZb()
    .businessFormed()
    .currentProductNotPurchased()
    .build()
});
